import { z } from "zod";

import type { DPElement as DocumentParseElement } from "../../../../types/laResult";

export type Element = DocumentParseElement;

// HighlightValueSchema만 필요한 경우를 위한 최소한의 스키마 정의
// 실제 사용 시에는 필요한 부분만 export

export const PrimitiveValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
]);

export const CoordinatesSchema = z.object({
  x: z.number(),
  y: z.number(),
});

export const HighlightValueSchema = z.object({
  _value: z.union([PrimitiveValueSchema, z.array(PrimitiveValueSchema)]),
  page: z.number(),
  coordinates: z.array(CoordinatesSchema),
  /**
   * (선택) 하이라이트를 표현할 때 사용할 색상 정보
   * - Tailwind 테마의 색상 키 또는 토큰 (예: "blue", "orange", "accent-blue")
   * - 구체적인 표현(HEX, hsl 등)은 소비 측(뷰어)에서 매핑하여 사용
   */
  color: z.string().optional(),
});

// HighlightValue 타입을 추론
export type HighlightValue = z.infer<typeof HighlightValueSchema>;

/**
 * 하이라이트 값에 고유 ID를 추가한 타입
 * 여러 기능(IE, DP, Image Viewer)에서 공통으로 사용되는 타입
 *
 * @example
 * {
 *   id: "highlight-123",
 *   _value: "2021",
 *   page: 1,
 *   coordinates: [{"x": 100, "y": 100}, {"x": 200, "y": 200}],
 *   document_id: "7f26abce-35c0-4a82-865e-78349cffab2c"
 * }
 */
export interface HighlightValueWithId extends HighlightValue {
  /** 하이라이트를 구분하기 위한 고유 ID (value가 동일할 때 이를 구분하기 위해 추가) */
  id: string;
  /** 하이라이트가 속한 문서의 ID (다른 문서로 이동 시 사용) */
  document_id?: string;
}
